import { api } from "@/redux/api";

import {
	ApiHealthHistory,
	ApiHealthHistorySchema,
	ApiHealthOverview,
	ApiHealthOverviewSchema,
} from "../../pages/ApiHealth/schema/api-health";

/**
 * `baseQueryWithValidation` accepts a `responseSchema` but never applies it — the parse call is
 * commented out, and it discarded its result even when enabled. So a schema alone coerces nothing:
 * `checkedAt` arrives as an ISO string while every type here claims `Date`. Parsing in
 * `transformResponse` is what makes those types true at runtime.
 */
export const parseApiHealthOverview = (raw: unknown): ApiHealthOverview =>
	ApiHealthOverviewSchema.parse(raw);

export const parseApiHealthHistory = (raw: unknown): ApiHealthHistory =>
	ApiHealthHistorySchema.parse(raw);

export const apiHealthApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getApiHealthOverview: builder.query<ApiHealthOverview, void>({
			query: () => ({
				url: "api-health/overview",
				responseSchema: ApiHealthOverviewSchema,
			}),
			transformResponse: parseApiHealthOverview,
			providesTags: ["ApiHealth"],
		}),
		getApiHealthHistory: builder.query<ApiHealthHistory, { contractKey: string }>({
			query: ({ contractKey }) => ({
				// The key is `host:path`, so it has to survive the URL intact.
				url: `api-health/history/${encodeURIComponent(contractKey)}`,
				responseSchema: ApiHealthHistorySchema,
			}),
			transformResponse: parseApiHealthHistory,
			providesTags: ["ApiHealth"],
		}),
	}),
});

export const { useGetApiHealthOverviewQuery, useGetApiHealthHistoryQuery } = apiHealthApi;
